export const messages = {
  ctaIdle: 'Avvisami quando online',
  ctaActive: 'Ti avviseremo · Annulla',
  callNow: 'Chiama',
  toastWatchCreated: 'Ti avviseremo quando torna online',
  toastWatchRemoved: 'Notifica rimossa',
  toastBackOnline: 'È tornato online proprio ora',
  toastRateLimited: "Troppe richieste, riprova fra un'ora",
  toastGenericError: 'Errore, riprova',
  toastUserWaiting: (name: string) => `${name} ti sta cercando`,
  toastProfessionalOnline: (name: string) => `${name} è ora online`,
  toastProfessionalConnected: (name: string) => `${name} si è collegato`,
  ariaLabelIdle: (name: string) => `Avvisami quando ${name} torna online`,
  ariaLabelActive: (name: string) => `Annulla notifica per ${name}`,
  offlineDisabled: 'Sei offline',
} as const;
